var _defs, _path, _polygon, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220.22 220.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#222221;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.63,72.31a21.29,21.29,0,0,0-15-15.09c-13.22-3.57-66.24-3.57-66.24-3.57s-53,0-66.25,3.57a21.28,21.28,0,0,0-15,15.09c-3.55,13.31-3.55,41.08-3.55,41.08s0,27.76,3.55,41.07a21.28,21.28,0,0,0,15,15.09c13.22,3.57,66.25,3.57,66.25,3.57s53,0,66.24-3.57a21.29,21.29,0,0,0,15-15.09c3.54-13.31,3.54-41.07,3.54-41.07S198.17,85.62,194.63,72.31Z",
    transform: "translate(-3.28 -3.28)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "92.77 135.32 92.77 84.9 137.09 110.11 92.77 135.32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.39,223.5A110.11,110.11,0,1,1,223.5,113.38,110.24,110.24,0,0,1,113.39,223.5Zm0-211.87A101.76,101.76,0,1,0,215.15,113.38,101.87,101.87,0,0,0,113.39,11.63Z",
    transform: "translate(-3.28 -3.28)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube2);
export default __webpack_public_path__ + "static/media/youtube2.4454023b4bd26a8aae50a09245f60fe3.svg";
export { ForwardRef as ReactComponent };